<template>
  <div class="log">
    <div class="main-wrap">
      <div id="main-content">
        <div class="wrapper">
          <jm-crumbs :crm_id="this.$route.params.id"/>
          <div class="contduct">
            <div
              class="operation"
              v-permission="[1]">
              <el-select
                placeholder="操作类型"
                v-model="key"
                size="small"
                @change="fetchData"
                filterable>
                <el-option
                  v-for="(item, index) in options"
                  :key="index"
                  :label="item"
                  :value="index"/>
              </el-select>
            </div>
            <div class="result contduct">
              <div
                class="item"
                v-for="item in log"
                :key="item"
              >
                <dl class="userInfo">
                  <dt>{{ item.edit_time }}</dt>
                  <dd>{{ item.truename }} : {{ item.ip }}</dd>
                </dl>
                <div
                  class="list"
                  v-for="i in item.list"
                  :key="i"
                >
                  <div class="title">{{ i.title }}</div>
                  <el-table
                    :data="i.data"
                    class="tableList"
                    border
                    size="mini">
                    <el-table-column
                      prop="label"
                      label="字段名称"
                      align="center"
                      width="160"/>
                    <el-table-column
                      prop="old_value"
                      label="旧值"
                      align="center">
                      <template slot-scope="scope">
                        <jm-dict-select
                          v-model="scope.row.old_value.value"
                          v-if="scope.row.old_value !== null && typeof scope.row.old_value == 'object'"
                          :show="true"
                          :dict-type="scope.row.old_value.dict_type"
                          :type="scope.row.old_value.type"/>
                        <span v-else>{{ scope.row.old_value }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="new_value"
                      label="新值"
                      align="center">
                      <template slot-scope="scope">
                        <jm-dict-select
                          v-model="scope.row.new_value.value"
                          v-if="scope.row.new_value !== null && typeof scope.row.new_value == 'object'"
                          :show="true"
                          :dict-type="scope.row.new_value.dict_type"
                          :type="scope.row.new_value.type"/>
                        <span v-else>{{ scope.row.new_value }}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
            <div class="pagination">
              <el-pagination
                @size-change="fetchData"
                @current-change="fetchData"
                :current-page.sync="currentPage"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import jmDictSelect from '@/components/tool/select/dictSelect';

export default {
  components: { jmDictSelect },
  data() {
    return {
      currentPage: 1,
      total: 0,
      options: [],
      key: '',
      log: []
    };
  },
  methods: {
    fetchData() {
      this
        .$http
        ._get({
          url: `/index/log/contduct?edit_key=${this.key}&id=${this.id}&cur_page=${this.currentPage}`
        })
        .then(({ data }) => {
          this.options = data.log;
          this.log = data.res;
          this.total = data.count;
          window.scrollTo(0, 0);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  },
  mounted() {
    this.key = this.$route.params.key || 'all';
    this.id = this.$route.params.id || 0;
    this.fetchData();
  }
};
</script>

<style>
  .contduct .el-table th{
    padding: 0 !important;
  }
  .contduct .tableList .el-table__header-wrapper thead div{
    height:30px;
  }
  .contduct .el-table .cell{
    line-height: 30px;
  }
  .log .contduct .operation {
    position: relative;
    margin-bottom: 15px;
  }

  .log .contduct .result .item {
    overflow: hidden;
  }

  .log .contduct .result .userInfo {
    padding: .3725em 1em;
    background-color: #8492A6;
    font-weight: 300;
    font-size: 1.125em;
    color: #fff;
    overflow: hidden;
    -webkit-border-radius: 2px;
    -moz-border-radius: 2px;
    border-radius: 2px;
  }

  .log .contduct .result .userInfo dt {
    float: left;
  }

  .log .contduct .result .userInfo dd {
    float: right;
  }

  .log .contduct .result .list {
    padding: 1em;
    overflow: hidden;
  }

  .log .contduct .result .list:last-child {
    border: none;
  }

  .log .contduct .result .title {
    margin-bottom: .75em;
    font-weight: 300;
    font-size: 1.25em;
    color: #20A0FF;
  }

  .log .contduct .result .el-table {
    width: 36%;
  }

  .log .contduct .result .el-table td,
  .log .contduct .result .el-table th {
    height: 30px;
  }

  .log .contduct .pagination {
    padding: 1em;
    text-align: right;
  }
</style>
